///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { division as divisionType, filterEquipmentTypes } from "../helpers/types";

const getEquipmentsForAnalyticsFilters = (division, existingSelectedEquipments) => {
    if (existingSelectedEquipments === null) {
        return [filterEquipmentTypes.find(x => x.label === (division === divisionType.coy ? "V" : "E"))];
    } else {
        return existingSelectedEquipments;
    }
};
export default getEquipmentsForAnalyticsFilters;
